import { render, staticRenderFns } from "./Need.vue?vue&type=template&id=3cdacd97"
import script from "./Need.vue?vue&type=script&lang=js"
export * from "./Need.vue?vue&type=script&lang=js"
import style0 from "./Need.vue?vue&type=style&index=0&id=3cdacd97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports